<template>
  <div class="loginPage flex-center">
    <div class="loginFormBox">
      <div class="LoginBox">
        <div class="ul">
          <div class="box box1 flex-center">
            <p class="p2 FTC1">全域实况</p>
          </div>
          <div class="box box2 flex-center">
            <p class="p2 FTC2">联单监管</p>
          </div>
          <div class="box box3 flex-center">
            <p class="p2 FTC1">车辆监管</p>
          </div>
          <div class="box box4 flex-center">
            <p class="p2 FTC2">收运监管</p>
          </div>
          <div class="box box5 flex-center">
            <p class="p2 FTC1">清运分析</p>
          </div>
          <div class="from">
            <h2 class="head FTC3">监管平台登录中心</h2>
            <div class="formGroup">
              <Input prefix="md-person" placeholder="请输入登录账号" v-model="form.account" class="QHinputBig" maxlength="15"/>
            </div>
            <div class="formGroup">
              <Input prefix="md-lock" v-model="form.password" type="password" placeholder="请输入登录密码" maxlength="16" class="QHinputBig" />
            </div>
            <div class="formGroup flex-between">
              <div>
                <span class="QHset FTC1" style="font-size:17px;">如需访问，请联系红白蓝授权开通监管账号</span>
              </div>
            </div>
            <div class="formGroup">
              <Button type="primary" class="QHbtnBig" @click="helloQHslideverify()"><span class="FTC1">立即登录</span></Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <QHslideverify ref="QHslideverify" @success="login"></QHslideverify>
  </div>
</template>

<script>
import md5 from "js-md5";
import data from "./data.js";
import "./style/login.css";
export default {
  data() {
    return {
      show: false,
      form: { ...data.data },
    };
  },
  methods: {
    helloQHslideverify() {
      let that = this;
      if (!this.$validAll(this.form, data.rule)) {
        return;
      }
      var parameter = { ...this.form };
      parameter.password = md5(parameter.password);
      this.$refs.QHslideverify.show = true;
    },
    login() {
      let that = this;
      if (!this.$validAll(this.form, data.rule)) {
        return;
      }
      var parameter = { ...this.form };
      parameter.password = md5(parameter.password);
      this.$loading(true, "登录中...");
      this.$api.login(parameter).then((res) => {
        this.show = false;
        this.$loading(false);
        if (res.code == 0) {
          //全局存放用户信息
          this.$clearStorage(); //清理缓存
          localStorage.setItem("token", res.data.token);
          this.$setLocalStorage("user", res.data);
          this.$setLocalStorage("city", res.data.city);
          this.$setLocalStorage("cityFuqin", res.data.cityFuqin);
          this.$setLocalStorage("citySon", res.data.citySon);
          this.$setLocalStorage("addressFull", res.data.addressFull);
          this.$msg("登录成功", "success", 500, function () {
            that.$go("/");
          });
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
  },
};
</script>
